import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    '@keyframes fadeInWidgets': {
        '0%': {
            transform: 'translateY(-30px)',
            transition: 'transform 2s',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
    animateOnCurtainClosed: {
        opacity: 0,
        animation: '$fadeInWidgets 1s forwards 2s',
    },
    image: {
        width: '100%',
        marginBottom: 15,
    },
    title: {
        fontFamily: theme.typographyPresets.fonts.monserrat.black,
        fontSize: 12,
        lineHeight: '1.33',
        margin: 0,
        color: theme.colors.text.light,
    },
    subtitle: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.light.darkgrey,
    },
    item: {
        paddingLeft: 10,
        paddingRight: 10,

        '@media (min-width: 768px)': {
            width: 'calc(33.3% - 20px)',
            marginLeft: 10,
            marginRight: 10,
            paddingLeft: 0,
            paddingRight: 0,
            marginBottom: 20,
        },

        '@media (min-width: 900px)': {
            width: 'calc(25% - 20px)',
        },

        '@media (min-width: 1400px)': {
            width: 'calc(20% - 20px)',
        },
    },
    itemsContainer: {
        '@media (min-width: 768px)': {
            display: 'flex',
            flexWrap: 'wrap',
        },
    },
}))
